
export const constants = Object.freeze({
	textLimit: 256,
})

